import { render, staticRenderFns } from "./BackhaulTab.vue?vue&type=template&id=afff37c8"
import script from "./BackhaulTab.vue?vue&type=script&lang=js"
export * from "./BackhaulTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports